import { render, staticRenderFns } from "./TestVersion.vue?vue&type=template&id=16d46b6b&scoped=true&"
import script from "./TestVersion.vue?vue&type=script&lang=js&"
export * from "./TestVersion.vue?vue&type=script&lang=js&"
import style0 from "./TestVersion.vue?vue&type=style&index=0&id=16d46b6b&lang=scss&scoped=true&"
import style1 from "./TestVersion.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d46b6b",
  null
  
)

export default component.exports